import React from 'react';
import TabsUncontrolled from './examples/TabsUncontolled';
const Tabs = () => (
  <div>
    <h1>Tabs component</h1>
    <TabsUncontrolled />
  </div>
);
export default Tabs;
